// extracted by mini-css-extract-plugin
module.exports = {"letter":"TMLinkedinFloatingImg_letter__QTfpZ"};